import { createSelector } from '@reduxjs/toolkit'

import { selectMdfActivitiesState } from './selectMdfActivitiesState'

export const selectIsMdfActivitiesFetching = createSelector(
  [selectMdfActivitiesState],
  (state) => state.isLoading
)
